import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//工作量相关API

const examManage = {
    examSetting: {
        list: config => createAPI('/examSetting/list', 'post', config),
        initOption: config => createAPI('/examSetting/initOption', 'post', config),
        initExamInfo: config => createAPI('/examSetting/initExamInfo', 'post', config),
        saveRec: config => createAPI('/examSetting/saveRec', 'post', config),
        delRec: config => createAPI('/examSetting/delRec', 'post', config),
        queryClassTree: config => createAPI('/examSetting/queryClassTree', 'post', config),

        queryExamTimeList: config => createAPI('/examSetting/queryExamTimeList', 'post', config),
        saveExamTime: config => createAPI('/examSetting/saveExamTime', 'post', config),
        delExamTime: config => createAPI('/examSetting/delExamTime', 'post', config),

        queryInvigilator: config => createAPI('/examSetting/queryInvigilator', 'post', config),
        saveMaxInvigilator: config => createAPI('/examSetting/saveMaxInvigilator', 'post', config),
        delTeacher: config => createAPI('/examSetting/delTeacher', 'post', config),
        queryInvigilatorTree: config => createAPI('/examSetting/queryInvigilatorTree', 'post', config),
        saveAddTeacher: config => createAPI('/examSetting/saveAddTeacher', 'post', config),

        queryExamSite: config => createAPI('/examSetting/queryExamSite', 'post', config),
        delExamSite: config => createAPI('/examSetting/delExamSite', 'post', config),
        querySiteTree: config => createAPI('/examSetting/querySiteTree', 'post', config),
        saveAddSite: config => createAPI('/examSetting/saveAddSite', 'post', config),
        
        queryExamCourseSet: config => createAPI('/examSetting/queryExamCourseSet', 'post', config),
        examCourseSetOption: config => createAPI('/examSetting/examCourseSetOption', 'post', config),
        saveCourseSet: config => createAPI('/examSetting/saveCourseSet', 'post', config),

        queryClassExamInfo: config => createAPI('/examSetting/queryClassExamInfo', 'post', config),
        classCourseOption: config => createAPI('/examSetting/classCourseOption', 'post', config),
        queryTeacher: config => createAPI('/examSetting/queryTeacher', 'post', config),
        querySite: config => createAPI('/examSetting/querySite', 'post', config),
        saveKCAP: config => createAPI('/examSetting/saveKCAP', 'post', config),

        resitList: config => createAPI('/examSetting/resitList', 'post', config),
        saveResitInfo: config => createAPI('/examSetting/saveResitInfo', 'post', config),
        queryResitSetInfo: config => createAPI('/examSetting/queryResitSetInfo', 'post', config),
        delResit: config => createAPI('/examSetting/delResit', 'post', config),
    },
    examSchedule: {
        list: config => createAPI('/examSchedule/list', 'post', config),
        initOption: config => createAPI('/examSchedule/initOption', 'post', config),
        examOption: config => createAPI('/examSchedule/examOption', 'post', config),
        baseParam: config => createAPI('/examSchedule/baseParam', 'post', config),
        queryExamInfo: config => createAPI('/examSchedule/queryExamInfo', 'post', config),
        autoArrangeExam: config => createAPI('/examSchedule/autoArrangeExam', 'post', config),
        resitArrangeList: config => createAPI('/examSchedule/resitArrangeList', 'post', config),
        resitStuInfo: config => createAPI('/examSchedule/resitStuInfo', 'post', config),
        saveResitInfo: config => createAPI('/examSchedule/saveResitInfo', 'post', config),
        saveExamArrange: config => createAPI('/examSchedule/saveExamArrange', 'post', config),
        queryStuSiteList: config => createAPI('/examSchedule/queryStuSiteList', 'post', config),
        saveExamSiteChange: config => createAPI('/examSchedule/saveExamSiteChange', 'post', config),
    },
    examSearch: {
        list: config => createAPI('/examSearch/list', 'post', config),
        initOption: config => createAPI('/examSearch/initOption', 'post', config),
        queryClassTree: config => createAPI('/examSearch/queryClassTree', 'post', config),
        queryTeaTree: config => createAPI('/examSearch/queryTeaTree', 'post', config),
        baseParam: config => createAPI('/examSearch/baseParam', 'post', config),
        queryExamInfo: config => createAPI('/examSearch/queryExamInfo', 'post', config),

        exportPaperBag: config => createAPI('/examSearch/exportPaperBag', 'post', config),
        exportExamArrange: config => createAPI('/examSearch/exportExamArrange', 'post', config),
        exportInvigilator: config => createAPI('/examSearch/exportInvigilator', 'post', config),
        exportStuSign: config => createAPI('/examSearch/exportStuSign', 'post', config),
        exportBkStuSign: config => createAPI('/examSearch/exportBkStuSign', 'post', config),
    },
};


export default examManage;



// WEBPACK FOOTER //
// ./src/api/modules/examManage.js